import React from 'react'
import { useFormContext } from 'react-hook-form'

import { ToolConfig } from 'data/hooks/agents/types'
import { SelectConnectionInput } from 'features/Agents/configuration/connections/SelectConnectionInput'

import { Field } from 'ui/components/Field'
import { Input } from 'ui/components/Input'

import { ConfigureToolFormInputs } from './ConfigureToolFormInputs'
import { ConfigureToolProps } from './types'

export const ConfigureSendEmailTool: React.FC<ConfigureToolProps> = ({ tool, agentSid }) => {
    const { register } = useFormContext<ToolConfig>()
    return (
        <>
            <SelectConnectionInput
                name="supplied_settings.automation_connection_sid"
                label="Automation connection"
                agentSid={agentSid}
                integrationId="google-mail"
            />
            <Field
                label="Recipient email override"
                helperText="If provided, all emails will be sent to this address. Useful for pre-production testing."
                shrink
            >
                <Input
                    placeholder="email address"
                    {...register('supplied_settings.recipient_email_override')}
                />
            </Field>
            <ConfigureToolFormInputs inputs={tool.inputs} />
        </>
    )
}
